<script>
import {
  BButtonGroup,
  BTabs,
  BTab,
  BCard,
  BCardText,
} from 'bootstrap-vue';
import Swal from 'sweetalert2';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BButtonGroup,
    BTabs,
    BTab,
    BCard,
    BCardText,
  },

  props: ['user', 'automation'],

  created () {
    this.tabIndex = this.tabs.findIndex((tab) => tab === window.location.hash);

    const hash = (window.location.hash).replace('#/', '');
    Bus.$emit('bulldeskHashChanged', hash);

    Bus.$on('bulldeskHashChanged', (tag) => {
      this.showSending = tag == 'sending';
    });
  },

  data () {
    return {
      view: null,
      tabIndex: 0,
      tabs: ['#/details', '#/actions', '#/options'],
      selected: this.automation,
      showSending: false,
    };
  },

  watch: {
    selected: {
      handler: _.debounce((automation) => {
        Bus.$emit('automationUpdated', automation);
      }, 2000),
      deep: true,
    },

    tabIndex () {
      this.view = this.tabs[this.tabIndex];
      window.location.hash = this.view;

      const hash = (window.location.hash).replace('#/', '');
      Bus.$emit('bulldeskHashChanged', hash);
    },
  },

  /**
     * Load mixins for the component.
     */
  methods: {
    async showModalSending () {
      const {
        rules = null,
      } = this.selected || {};

      if (! rules || rules.length === 0) {
        this.showSending = true;

        return;
      }

      const html = `<span class="bdk-mb-1 bdk-font-medium"> ${this.__('Essa é uma campanha automatizada que já está rodando de acordo com a sua regra.')} <br/><br/> ${this.__('Deseja enviar para outros leads?')}</span>`;

      if (await Confirm(null, null, html, 'bdk-text-sm')) {
        this.showSending = true;
      }
    },

    activate () {
      this.selected.active = true;
      this.update();
    },

    inactivate () {
      this.selected.active = false;
      this.update();
    },

    handleTypeChange (type) {
      this.selected.type = type;
      this.update();
    },

    async clone () {
      if (! await Confirm(this.__('Clonar campanha?'))) {
        return;
      }

      this.$http.post(`/automation/${this.selected.id}/clone`)
        .then(({ data }) => window.location.href = `/automation/${data.id}`)
        .catch(({ data }) => Alert.error(data.error));
    },

    update () {
      this.$http.put(`/automation/${this.selected.id}`, this.selected)
        .then(({ data }) => {
          console.log(data);
        });
    },

    template () {
      this.$http.post('/automation/template', {
        id: this.automation.id,
        title: `Template: ${this.automation.name}`,
      })
      .then(({ body: { message } }) => {
        Alert.info(message);
      });
    },
  },
};
</script>

<style lang="scss">
  @import '../../../sass/variables';

  .bd-automation {
    &__row {
      transition: padding 250ms;

      &--padding {
        padding-right: $timeline_width + 16;
      }
    }

    &__tabs {
      background: #FFF;
      border-top-left-radius: 16px;

      i,
      svg {
        color: #3b334a;
        margin-right: 8px;
      }

      .nav-item {
        &.right {
          margin-left: auto;
        }

        &:first-child .nav-link {
          margin-left: 32px;
        }

        &:last-child .nav-link {
          margin-right: 32px;
        }
      }

      .nav-link {
        border: 0;
        padding: 0;
        height: 75px;
        display: flex;
        margin: 0 16px;
        font-weight: 500;
        font-size: 13px;
        align-items: center;
        letter-spacing: -0.2px;
        color: #3b334a !important;
        font-family: 'Montserrat', sans-serif;

        &.active {
          border-bottom: 2px solid $green;

          i {
            color: $green;
          }

          svg {
            * {
              fill: $green !important;
              stroke: $green !important;
            }
          }
        }
      }
    }

    &__body {
      background: $white-gray-2;
    }

    &__timeline {
      right: 16px;
      z-index: 1;
      height: 100%;
      transition: 250ms;
      margin-left: -15px;
      position: absolute;
      width: $timeline_width;
      background-color: $white;
      box-shadow: 0 5px 20px rgba(103, 70, 162, 0.18);
      border-top-right-radius: 20px;

      #automation-timeline {
        border-top-right-radius: 20px;
      }

      &--hidden {
        width: 0px;
      }

      > .timeline {
        width: $timeline_width;
      }
    }
  }
</style>
